import React, { Component } from 'react';
import Reflux from 'reflux';
import { Actions } from '../components/Actions';
import * as Common from '../components/Common';
import Slider from 'react-slick';

import Footer from '../components/Footer';
import EventPop from '../components/EventPop';

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  useCSS: true
};

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEventPop: false,
      bannerList: null,
      bannerTextClassName: 'vis-txt',
      popupBanner: null
    };

    Reflux.createStore({
      init: function() {
        this.listenTo(Actions.doEventPopClose, this.doEventPopClose);
      },
      doEventPopClose: (isShow) => {
        Common.enableScroll();

        this.setState({ isEventPop: false });
        
        // 오늘 하루 보지 않기
        if(isShow) {
          this._setCookieMobile( "todayCookie", "done" , 1);
        }
      }
    });
  }

  componentDidMount() {
    this._getBanners('MAIN');
    this._getBanners('POPUP');

    document.body.classList.add('main');
  }

  _setCookieMobile ( name, value, expiredays ) {
    var todayDate = new Date();
    todayDate.setDate( todayDate.getDate() + expiredays );
    document.cookie = name + "=" + escape( value ) + "; path=/; expires=" + todayDate.toGMTString() + ";"
  }

  _getCookieMobile () {
    var isEventPop = document.cookie.indexOf("todayCookie=done") < 0;
    this.setState({ isEventPop: isEventPop });
    if(isEventPop) {
      Common.disableScroll();
    } else {
      Common.enableScroll();
    }
  }

  /**
   * 배너조회
   */
  _getBanners(bannerType) {
    Common.callApi('/banners', 'get', {bannerType: bannerType, branchType: 'StudyTOZ', platform: 'MOBILE'})
    .then(result => {
      var _resultDataList = result.resultDataList;
      if(_resultDataList != null && _resultDataList.length > 0) {
        if(bannerType === 'MAIN') {
          this.setState({ bannerList: _resultDataList });
        }
        if(bannerType === 'POPUP') {
          this.setState({ popupBanner: _resultDataList[0] });
          this._getCookieMobile();
        }
      }
    });
  }

  _bannerBeforeChange(before, next) {
    this.setState({
      bannerCurIdx: before,
      bannerNextIdx: next
    });

    var txtTimer = null;
    if(next > 4 && before < next) {
      // txtTimer = setTimeout(() => {
        this.setState({ bannerTextClassName: 'vis-txt off' });
        // clearTimeout(txtTimer);
      // }, 100);
    } else {
      txtTimer = setTimeout(() => {
        this.setState({ bannerTextClassName: 'vis-txt' });
        clearTimeout(txtTimer);
      }, 100);
    }
  }

  _renderBannerList() {
    return (
      <Slider beforeChange={(current, next) => this._bannerBeforeChange(current, next)} {...settings} className="main-slide">
        { this.state.bannerList.map((entity, index) => <img key={index} src={entity.bannerImgUrl} style={{ backgroundImage: 'url(' + entity.bannerImgUrl + ')',  backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'cover' }} alt="banner" onClick={() => Common.doMoveBannerLink(entity)} />) }
      </Slider>
    )
  }

  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap" className="div-cont" >
            <div id="contents">
                <div className="main-vis">

                  <p className="mt-logo"><span className="blind">TOZ StudyCenter</span></p>
                  <div className={this.state.bannerTextClassName}>
                    <p className="stxt">
                      17년 공간 서비스 전문 회사가 만든
                      <strong>No.1* 학습공간</strong>
                    </p>
                    <p className="btxt"><strong>토즈</strong> 스터디센터</p>
                  </div>

                  { this.state.bannerList ? this._renderBannerList() : "" }
                </div>

                <div className="main-txt">
                  <p className="stxt">70만이 선택한 최적의 학습공간!</p>
                  <p className="btxt">
                    가까운 토즈에서<br/>
                    <strong><span className="point">무료로</span> 직접 <span className="point">공부</span>해 보세요</strong>
                  </p>
                  <a href="/introduce" className="info-btn"><span className="blind">둘러보기</span></a>
                </div>
                  
                <Footer />
              </div>
            </div>
          </div>
        </div>

        {this.state.isEventPop ? <EventPop banner={this.state.popupBanner} /> : ''}
      </div> 
    )
  }
}

export default Home;